import { Navigate, useSearchParams } from "react-router";
import { useTranslation } from "@ncp/i18n";
import { PageHeader } from "@ncp/ui";
import { CaseRegisterTable } from "../features/registers/CaseRegister";

/** Each process outside the three main sections has its own page and name (7.27): exemption applications, grievances, legal enquiries. */
export const PROCESS_PAGES = {
  Exemption: { href: "/exemptions", labelKey: "nav.exemptions" },
  ExemptionAmendment: { href: "/exemptions", labelKey: "nav.exemptions" },
  Appeal: { href: "/grievances", labelKey: "nav.grievances" },
  LegalEnquiry: { href: "/legal-enquiries", labelKey: "nav.legalEnquiriesInternal" },
} as const;

export function ProcessRegisterPage({ type }: { type: "Exemption" | "Appeal" | "LegalEnquiry" }) {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader title={t(PROCESS_PAGES[type].labelKey)} />
      <CaseRegisterTable type={type} />
    </div>
  );
}

/** The former "Other requests" page: its addresses (`/requests?type=…`) open the page of the process they name. */
export function OtherRequestsRedirect() {
  const [params] = useSearchParams();
  const type = params.get("type") as keyof typeof PROCESS_PAGES | null;
  return <Navigate to={type && type in PROCESS_PAGES ? PROCESS_PAGES[type].href : PROCESS_PAGES.Exemption.href} replace />;
}
